var _rect, _rect2, _rect3, _rect4, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHorizontalHmi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 49,
    viewBox: "0 0 100 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 22,
    rx: 2.5,
    stroke: "#CDD0D4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 7,
    width: 31,
    height: 2,
    rx: 1,
    fill: "#CDD0D4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 14,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#CDD0D4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 99,
    height: 22,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 0 48)",
    stroke: "#CDD0D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5996 38.744H39.1756V43H37.5936V33.228H39.1756V37.344H43.5996V33.228H45.1816V43H43.5996V38.744ZM55.0638 35.524H54.9938L54.2238 37.106L52.0818 41.012L49.9398 37.106L49.1698 35.524H49.0998V43H47.5878V33.228H49.4638L52.0818 38.198H52.1658L54.7838 33.228H56.5758V43H55.0638V35.524ZM58.5701 43V41.712H59.9001V34.516H58.5701V33.228H62.8261V34.516H61.4821V41.712H62.8261V43H58.5701Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalHmi);
export default __webpack_public_path__ + "static/media/horizontalHmi.8cf55c82cb5cdbfc36f8095c872483e2.svg";
export { ForwardRef as ReactComponent };